import script from "./GoogleAuthBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleAuthBtn.vue?vue&type=script&setup=true&lang=js"

import "./GoogleAuthBtn.vue?vue&type=style&index=0&id=775e6c87&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-775e6c87"]])

export default __exports__